import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

import { PermissionsContext, Permissions } from './context';

export interface WithPermissionsProps {
  permissions: Permissions;
}

export function withPermissions<P extends object>(WrappedComponent: React.ComponentType<P & WithPermissionsProps>): React.ComponentType<P> {
  const HoC: React.FC<P> = props => (
    <PermissionsContext.Consumer>
      {permissions => <WrappedComponent {...props} permissions={permissions} />}
    </PermissionsContext.Consumer>
  );

  HoC.displayName = `WithPermissions(${getDisplayName(WrappedComponent)})`;

  return hoistNonReactStatics(HoC, WrappedComponent);
}
